<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
		<div class="-two-columns">
		<!-- <div class="o-form -two-columns"> -->
			<div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>

            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Catégories</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h1 class="o-form__title">Métier</h1> -->
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            />
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Nom de la catégorie"
                                    label="Nom de la catégorie"
                                    required=true
                                    error-message="Ce champ est requis"
                                    v-model="form.name"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <!-- <Input
                                    type="text"
                                    name="color"
                                    label="Couleur"
                                    required=false
                                    error-message="Ce champ est requis"
                                    v-model="form.color"
                                /> -->

                                <q-input
                                    v-model="form.color"
                                    class="my-input"
                                    @focus="$refs.pickerProxy.show()"
                                    label="Couleur"
                                    placeholder="#000000"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                >
                                        <template v-slot:before>
                                            <q-icon name="bookmark"
                                                :style="'color: ' + form.color"
                                                @click="$refs.pickerProxy.show()"
                                            />
                                        </template>
                                        <template v-slot:append>
                                        <q-icon name="colorize" class="cursor-pointer"
                                        >
                                            <q-popup-proxy ref="pickerProxy" transition-show="scale" transition-hide="scale">
                                            <q-color v-model="form.color" />
                                            </q-popup-proxy>
                                        </q-icon>
                                    </template>
                                </q-input>

                                <!-- <q-input
                                    filled
                                    v-model="secondColor"
                                    :rules="['anyColor']"
                                    hint="With validation"
                                    class="my-input"
                                >
                                    <template v-slot:append>
                                    <q-icon name="colorize" class="cursor-pointer">
                                        <q-popup-proxy transition-show="scale" transition-hide="scale">
                                        <q-color v-model="secondColor" />
                                        </q-popup-proxy>
                                    </q-icon>
                                    </template>
                                </q-input> -->

                            </div>

                            <div class="o-form__item">
                                <Input
                                    type="textarea"
                                    v-model="form.description"
                                    label="Description"
                                    autogrow
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>

                            <div class="o-form__item">

                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox size="xs" dense v-model="form.is_project_category" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Catégorie de projet</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox size="xs" dense v-model="form.is_company_category" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Catégorie de compagnie</q-item-label>
                                    </q-item-section>
                                </q-item>

                            </div>


                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { CATEGORIES } from '@/graphql/category/queries'
    import { UPSERTCATEGORY, DELETECATEGORY, RESTORECATEGORY } from '@/graphql/category/mutations'
    import { removeNULL } from '@/js/utilities'

    export default {
        name: 'categories',
        apollo: {
            categories: {
                query: CATEGORIES,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        trashed: this.trashed,
                        first: this.perPage,
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(categories) {
                    this.listbox.listItems = Object.assign([], categories.categories)
                    return categories;
                }
            },
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchable: 'Rechercher / filtrer'
                },
                form: {},
                newItem: {
                    id: 0,
                    name: null,
                    description: null,
                    color: '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
                },
                showDeleted: false,
                perPage: 50,
            }
        },
        mounted: async function(){
            this.setNewItem();
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form = Object.assign({}, item);
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form=Object.assign({}, this.newItem);
                this.form.color = '#' + (Math.random() * 0xFFFFFF << 0).toString(16)

                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=0;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETECATEGORY,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.categories) this.$apollo.queries.categories.refetch()
                        this.setSelected(null);
                    }
                })
                this.setNewItem();
            },
            saveItem(form) {
                // console.log(form)
                form=removeNULL(form);
                this.$apollo.mutate({
                    mutation: UPSERTCATEGORY,
                    variables: { ...form },
                    update: (store, { data: { upsertCategory } }) => {
                        console.log(form)
                        if (!form.id || form.id==0) {
                            // let myVariables = { trashed: this.trashed }
                            const data = store.readQuery({ query: CATEGORIES })
                            console.log(data)
                            data.categories.push(upsertCategory);
                            store.writeQuery({
                                query: CATEGORIES,
                                data,
                            })
                        }
                        if (this.$apollo.queries.categories) this.$apollo.queries.categories.refetch()
                        this.setSelected(upsertCategory)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Category : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {

                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORECATEGORY,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { category } }) => {
                        if(!form.id){
                            const data = store.readQuery({ query: CATEGORIES })
                            data.categories.push(category);
                            store.writeQuery({
                                query: CATEGORIES,
                                data,
                            })
                        }
                        this.setSelected(category)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Ressource : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
